import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSkills = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1.49951C9.32043 1.49972 10.3906 2.57063 10.3906 3.89111H13.3047V7.60205C12.4244 7.60205 11.7109 8.31549 11.7109 9.1958C11.7112 10.0208 12.338 10.7001 13.1416 10.7817L13.3047 10.7896V14.5005H9.58398C9.58398 13.6255 8.87492 12.9157 8 12.9155C7.12493 12.9155 6.41504 13.6254 6.41504 14.5005H2.69531V3.89111H5.6084C5.6084 2.5705 6.67939 1.49951 8 1.49951Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSkills;
